import React from "react";
import styled from "styled-components";
import fipayFonts from "../../theme/index";

interface OurVisionProps {}

const images = [
  {
    imgPath: "/assets/icons/vision.png",
    TextHeader: "Our Vision",
    MidFirstText: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus
      libero nulla, nec dignissim nisi semper ac. Pellentesque lorem leo, tempus at semper nec, 
      auctor ac nibh nec dignissim nisi semper ac.`,
    MidSecondText: `In hac habitasse platea dictumst. Vivamus
      vestibulum tortor ac leo maximus, vitae tincidunt diam molestie. Aenean
      eu leo quam. Pellentesque lorem leo, tempus at semper nec, auctor ac
      nibh nec dignissim nisi semper ac.`,
  },
];

const OurVision: React.FC<OurVisionProps> = () => {
  return (
    <OurVisionContainer>
      <VisionText>
        <AboutUsContainer>
          <AboutUsText>VISION</AboutUsText>
        </AboutUsContainer>
        <OurVisionTitle>{images[0].TextHeader}</OurVisionTitle>
        <FirstParagraph>{images[0].MidFirstText}</FirstParagraph>
        <SecondParagraph>{images[0].MidSecondText}</SecondParagraph>
      </VisionText>
      <VisionImage src={images[0].imgPath} alt="Vision" />
    </OurVisionContainer>
  );
};

const OurVisionContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f7f7f7;
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 3rem;
  padding-right: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding-left: 2rem;
  }
`;

const VisionImage = styled.img`
  width: 50%;
  height: auto;

  @media (max-width: 768px) {
    width: 115%;
    margin-left: 1.5rem;
  }
`;

const VisionText = styled.div`
  width: 50%;
  padding: 0 4rem;

  @media (max-width: 768px) {
    width: 100%;
    /* padding: 2rem; */
    margin-left: 2rem;
    margin-right: 2rem;
  }
`;

const AboutUsText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: centre;
  color: #00c703;
`;

const AboutUsContainer = styled.div`
  background-color: #fff;
  border-radius: 30px;
  text-align: center;
  display: inline-block;
  width: 24%;
  height: 1%;
  margin-bottom: 1px;

  @media (max-width: 768px) {
    width: 55%;
    height: 1%;
  }
`;

const FirstParagraph = styled.p`
  text-align: left;
  margin-bottom: 2rem;
  color: #5e5e5e;
  ${fipayFonts.fipayFonts.body1}

  @media screen and (min-width: 0px) and (max-width: 766px) {
    padding-left: 0.01rem;
  }
`;
const SecondParagraph = styled.p`
  text-align: left;
  color: #5e5e5e;
  ${fipayFonts.fipayFonts.body1}

  @media screen and (min-width: 0px) and (max-width: 766px) {
    padding-left: 0.01rem;
  }
`;

const OurVisionTitle = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 45px;
  font-weight: 700;
  line-height: 64px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 0px;
  color: #09005b;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 26px;
    line-height: 34.35px;
    padding-left: 0.01rem;
  }
  ${fipayFonts.fipayFonts.heading1};
`;

export default OurVision;
